import { url } from '@/helpers/UrlHelpers';
import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';

export default class RemoveFromOrder {
    apiService

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
        this.apiService.enableAuth();
    }

    handle(subscriptionId, productId) {
        let apiUrl = url(ApiEndpoints['shop.order.remove'], [subscriptionId, productId]);

        return this.apiService.delete(apiUrl);
    }
}
